import type { TranslateFunc } from 'src/components/translate';
import type { GetFilterFunc } from '../../offer-list-filter-context/types';
import { FilterType } from 'src/components/price-list/types';
import { getSelectionsString } from '../../product-variants/utils/selections';

export const getVariantSelections = (
  t: TranslateFunc,
  getFilter: GetFilterFunc
) => {
  const conditions = getSelectionsString(t, getFilter(FilterType.CONDITION));
  const sizes = getSelectionsString(t, getFilter(FilterType.VARIANT_SIZE));
  const colors = getSelectionsString(t, getFilter(FilterType.VARIANT_COLOR));
  return [conditions, sizes, colors].filter(x => x).join(', ');
};
